module.exports = function() {
  return new Worker(__webpack_public_path__ + "8307e7af01943731b030.worker.js");
};